<h2 mat-dialog-title>新規登録</h2>

<mat-dialog-content class="mat-typography">
  <mat-form-field class="item">
    <mat-label>名称</mat-label>
    <input matInput type="text" maxlength="20" [formControl]="nameControl">
    <mat-hint align="end">{{ nameControl.value?.length || 0 }}/20</mat-hint>
    <mat-error *ngIf="nameControl.hasError('required')">
      名称を入力してください。
    </mat-error>
  </mat-form-field>

  <mat-form-field class="item">
    <mat-label>地名（住所）</mat-label>
    <input matInput type="text" maxlength="20" [formControl]="addressControl">
    <mat-hint align="end">{{ addressControl.value?.length || 0 }}/20</mat-hint>
    <mat-error *ngIf="addressControl.hasError('required')">
      住所を入力してください。
    </mat-error>
  </mat-form-field>

  <mat-form-field class="item">
    <mat-label>緯度</mat-label>
    <input matInput type="number" min="-90" max="90" [formControl]="latitudeControl">
    <mat-error *ngIf="latitudeControl.hasError('min')">
      -90以上の値を入力してください。
    </mat-error>
    <mat-error *ngIf="latitudeControl.hasError('max')">
      90以下の値を入力してください。
    </mat-error>
  </mat-form-field>

  <mat-form-field class="item">
    <mat-label>経度</mat-label>
    <input matInput type="number" min="-180" max="180" [formControl]="longitudeControl">
    <mat-error *ngIf="longitudeControl.hasError('min')">
      -180以上の値を入力してください。
    </mat-error>
    <mat-error *ngIf="longitudeControl.hasError('max')">
      180以下の値を入力してください。
    </mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="operation-container">
  <button mat-button [mat-dialog-close]="null">閉じる</button>
  <button mat-raised-button color="primary" (click)="onAdd()">追加する</button>
</mat-dialog-actions>

